

export function getTimezones() {
    return Intl.supportedValuesOf('timeZone');
}

export function getBrowserTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

//# sourceMappingURL=TimezoneHelper.js.map
